import ChatInterface from './ChatInterface';

export default ChatInterface;